import { render, staticRenderFns } from "./childrenTeams.vue?vue&type=template&id=14a2ed13&scoped=true&"
import script from "./childrenTeams.vue?vue&type=script&lang=js&"
export * from "./childrenTeams.vue?vue&type=script&lang=js&"
import style0 from "./childrenTeams.vue?vue&type=style&index=0&id=14a2ed13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2ed13",
  null
  
)

export default component.exports